import React, { FC, memo } from 'react'
import './NotFound.scss'
import { Container } from 'react-bootstrap'

const NotFound: FC = () => (
  <Container fluid>
    <div className="center">
      <img className="image" src="/assets/img/not-found.png" alt="Alerta" />
      <br />
      <h1>404</h1>
      <h2>Not Found</h2>
    </div>
  </Container>
)

export default memo(NotFound)
